import { __assign, __decorate, __extends, __rest } from "tslib";
import React from 'react';
import { Misc, Utils } from "@singularsystems/neo-core";
import { observer } from "mobx-react";
import PageSizeControl from './PageSizeControl';
import { NeoReactTypes } from '../../Modules/Types';
var SimplePagerControls = /** @class */ (function (_super) {
    __extends(SimplePagerControls, _super);
    function SimplePagerControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iconFactory = Misc.Globals.appService.get(NeoReactTypes.Components.IconFactory);
        return _this;
    }
    SimplePagerControls.prototype.render = function () {
        var _a = this.props, pageManager = _a.pageManager, noOfButtons = _a.noOfButtons, alignment = _a.alignment, firstText = _a.firstText, prevText = _a.prevText, nextText = _a.nextText, lastText = _a.lastText, autoHide = _a.autoHide, pageSizeLabel = _a.pageSizeLabel, domProps = __rest(_a, ["pageManager", "noOfButtons", "alignment", "firstText", "prevText", "nextText", "lastText", "autoHide", "pageSizeLabel"]);
        noOfButtons = noOfButtons || 7;
        alignment = alignment || "end";
        alignment = alignment === "start" ? "" : alignment;
        firstText = firstText || Misc.Settings.pager.firstText;
        prevText = prevText || Misc.Settings.pager.prevText;
        nextText = nextText || Misc.Settings.pager.nextText;
        lastText = lastText || Misc.Settings.pager.lastText;
        var className = Utils.joinWithSpaces(domProps.className, "neo-pager-controls", pageSizeLabel ? "justify-content-between" : (alignment && "justify-content-" + alignment));
        var firstButton = Math.max(1, pageManager.pageNo - Math.floor(noOfButtons / 2));
        var lastButton = firstButton + noOfButtons;
        if (lastButton > pageManager.totalPages) {
            lastButton = pageManager.totalPages + 1;
            firstButton = Math.max(1, lastButton - noOfButtons);
        }
        var buttons = [];
        var _loop_1 = function (i) {
            buttons.push(React.createElement("li", { key: i, className: "page-item" + (i === pageManager.pageNo ? " active" : "") },
                React.createElement("a", { className: "page-link", href: "#", onClick: function (e) { e.preventDefault(); pageManager.pageNo = i; } }, i)));
        };
        for (var i = firstButton; i < lastButton; i++) {
            _loop_1(i);
        }
        return ((pageManager.totalPages > 1 || autoHide === false) &&
            React.createElement("div", { className: className },
                pageSizeLabel && React.createElement(PageSizeControl, { pageManager: this.props.pageManager, label: pageSizeLabel }),
                React.createElement("ul", __assign({}, domProps, { className: "pagination" }),
                    React.createElement("li", { className: "page-item" + (pageManager.pageNo === 1 ? " disabled" : "") },
                        React.createElement("a", { className: "page-link", href: "#", onClick: function (e) { e.preventDefault(); pageManager.firstPage(); } }, this.iconFactory.textOrIcon(firstText))),
                    React.createElement("li", { className: "page-item" + (pageManager.pageNo === 1 ? " disabled" : "") },
                        React.createElement("a", { className: "page-link", href: "#", onClick: function (e) { e.preventDefault(); pageManager.previousPage(); } }, this.iconFactory.textOrIcon(prevText))),
                    buttons,
                    React.createElement("li", { className: "page-item" + (pageManager.pageNo === pageManager.totalPages ? " disabled" : "") },
                        React.createElement("a", { className: "page-link", href: "#", onClick: function (e) { e.preventDefault(); pageManager.nextPage(); } }, this.iconFactory.textOrIcon(nextText))),
                    React.createElement("li", { className: "page-item" + (pageManager.pageNo === pageManager.totalPages ? " disabled" : "") },
                        React.createElement("a", { className: "page-link", href: "#", onClick: function (e) { e.preventDefault(); pageManager.lastPage(); } }, this.iconFactory.textOrIcon(lastText))))));
    };
    SimplePagerControls = __decorate([
        observer
    ], SimplePagerControls);
    return SimplePagerControls;
}(React.Component));
export default SimplePagerControls;
